import ArtLayer from "../art/ArtLayer";
import Birds from "../art/Birds";
import { RoseCorner } from "../art/Flora";
import palace from "../../../images/royal-mahal/palace.webp";

/** The lake palace painting (src/images/royal-mahal/palace.webp, transparent sky). */
export const Palace = ({ className = "" }) => (
  <img className={`rm-painting rm-palace ${className}`} src={palace} alt="" draggable="false" />
);

// Masked to the painting's own silhouette, so tinting it darkens only the palace.
const palaceMask = { WebkitMaskImage: `url(${palace})`, maskImage: `url(${palace})` };

/**
 * The world of the invitation: the lake palace along the lower right (it brings
 * its own bougainvillea), birds in the open sky and, on wide screens, roses in
 * the empty corner by the lake. The gate, the opening page and the closing page
 * all stand in this same scenery. `dusk` adds a tint layer the opening scene
 * fades in as night falls.
 */
const Scenery = ({ className = "", dusk = false, birds = true }) => (
  <div className={`rm-scenery ${className}`} aria-hidden="true">
    <div className="rm-scenery__vista">
      <Palace />
      {dusk && <div className="rm-scenery__dusk" style={palaceMask} />}
    </div>
    {birds && <Birds className="rm-scenery__birds" />}
    <div className="rm-scenery__layer rm-scenery__layer--roses-left">
      <ArtLayer slot="rosesLeft">
        <RoseCorner />
      </ArtLayer>
    </div>
  </div>
);

export default Scenery;
